// Endpoint functions for the FastAPI backend.
import API from "./api";
import { jurisdiction } from "../modules/state";

export const healthCheck = () => API.get("/health");

export const initSessionWithScan = async (scan, documentId, userId) => {
  return API.post("/session/init", {
    body: {
      document_id: documentId || undefined,
      user_id: userId || undefined,
      scan,
    },
  });
};

export const chat = async (
  sessionId,
  documentId,
  userQuery,
  selection = null,
  suggestEdits = false,
  mode = null
) => {
  const body = {
    session_id: sessionId,
    document_id: documentId,
    user_query: userQuery,
    suggest_edits: suggestEdits,
    country: jurisdiction || "CTH",
    ...(mode ? { mode } : {}),
  };

  if (selection) {
    body.selection = {
      node_ids: selection.node_ids || selection.nodeIds || [],
      node_texts: selection.node_texts || selection.nodeTexts || null,
      text: selection.text || selection.selectionText || "",
    };
  }

  return API.post("/session/chat", { body });
};

export const getDocumentStatus = (documentId) =>
  API.get(`/document/${encodeURIComponent(documentId)}/status`);

export const getChatHistory = (documentId, limit = 5, offset = 0) =>
  API.get(`/document/${encodeURIComponent(documentId)}/chat-history`, {
    query: { limit, offset },
  });

export const getDocumentTree = (documentId) =>
  API.get(`/document/${encodeURIComponent(documentId)}/tree`);

export const sendDelta = (documentId, added = [], removed = [], updated = []) =>
  API.post("/document/delta", {
    body: { document_id: documentId, added, removed, updated },
  });
